module.exports = __webpack_public_path__ + "static/MobileAppLearning@3x-fcd072029b2d870bcf5cd1ba99f9e062.png";